// src/components/PackingLists/ViewControls.js
import React from 'react';

/**
 * ViewControls component provides UI for changing the view of the packing list
 * 
 * @param {Object} props - Component props
 * @param {string} props.groupBy - Current groupBy setting ('none', 'category', 'location')
 * @param {Function} props.setGroupBy - Function to update the groupBy setting
 * @param {string} props.viewDensity - Current view density ('relaxed', 'compressed')
 * @param {Function} props.setViewDensity - Function to update the view density
 * @returns {JSX.Element} Rendered component
 */
const ViewControls = ({ groupBy, setGroupBy, viewDensity, setViewDensity }) => {
  return (
    <div className="card mb-3">
  <div className="card-body">
    <div className="d-flex flex-wrap gap-4 align-items-center">
      {/* View by control */}
      <div className="d-flex align-items-center">
        <label className="me-2 fw-medium">View by:</label>
        <div className="btn-group" role="group" aria-label="View grouping options">
          <input 
            type="radio" 
            className="btn-check" 
            name="groupBy" 
            id="groupByNone" 
            value="none" 
            checked={groupBy === 'none'} 
            onChange={() => setGroupBy('none')} 
          />
          <label className="btn btn-outline-secondary" htmlFor="groupByNone">All</label>
          
          <input 
            type="radio" 
            className="btn-check" 
            name="groupBy" 
            id="groupByCategory" 
            value="category" 
            checked={groupBy === 'category'} 
            onChange={() => setGroupBy('category')} 
          />
          <label className="btn btn-outline-secondary" htmlFor="groupByCategory">By Category</label>
          
          <input 
            type="radio" 
            className="btn-check" 
            name="groupBy" 
            id="groupByLocation" 
            value="location" 
            checked={groupBy === 'location'} 
            onChange={() => setGroupBy('location')} 
          />
          <label className="btn btn-outline-secondary" htmlFor="groupByLocation">By Location</label>
        </div>
      </div>
      
      {/* Density control */}
      <div className="d-flex align-items-center">
        <label className="me-2 fw-medium">Density:</label>
        <div className="btn-group" role="group" aria-label="View density options">
          <input 
            type="radio" 
            className="btn-check" 
            name="viewDensity" 
            id="densityRelaxed" 
            value="relaxed" 
            checked={viewDensity === 'relaxed'} 
            onChange={() => setViewDensity('relaxed')} 
          />
          <label className="btn btn-outline-secondary" htmlFor="densityRelaxed">Relaxed</label>
          
          <input 
            type="radio" 
            className="btn-check" 
            name="viewDensity" 
            id="densityCompressed" 
            value="compressed" 
            checked={viewDensity === 'compressed'} 
            onChange={() => setViewDensity('compressed')} 
          />
          <label className="btn btn-outline-secondary" htmlFor="densityCompressed">Compressed</label>
        </div>
      </div>
    </div>
  </div>
</div>
  );
};

export default ViewControls;